import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail, MapPin, PhoneCallIcon, Instagram } from 'lucide-react';
import contactData from '../data/contact.json';

const Contact = () => {
  const iconMap = {
    Linkedin,
    Instagram,
    Mail,
    MapPin,
    PhoneCallIcon
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.6 }}
      className="bg-card rounded-lg p-8 shadow-lg"
    >
      <h2 className="section-heading mb-8">Contact</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {contactData.socialLinks.map((link, index) => {
          const IconComponent = iconMap[link.icon];
          return (
            <a key={index} href={link.url} className="contact-info">
              <IconComponent className="w-6 h-6 text-primary" />
              <span>{link.label}</span>
            </a>
          );
        })}
        {contactData.contactInfo.map((info, index) => {
          const IconComponent = iconMap[info.icon];
          return (
            <div key={index} className="contact-info">
              <IconComponent className="w-6 h-6 text-primary" />
              <span>{info.value}</span>
            </div>
          );
        })}
      </div>
    </motion.section>
  );
};

export default Contact;
